import { connect } from 'react-redux'
import { actions } from './CaptchaSlice'
import CaptchaPage from './components/CaptchaPage'
import * as flags from 'src/features/asyncFlags/AsyncFlagsSelector'

const mapStateToProps = state => ({
  token: state.captchaReducer.meta.token,
  busy: flags.isBusy('captchaLogin')(state)
})

const mapDispatchToProps = dispatch => ({
  requestCaptchaLogin: captchaToken =>
    dispatch(actions.requestCaptchaLogin({ captchaToken }))
})

export default connect(mapStateToProps, mapDispatchToProps)(CaptchaPage)
